 <div class="cell-container" (click)="select()" (dblclick)="focus()">
    <div class="content">
        <i [class]="tag.icon" 
            [style.color]="tag.color" 
            [title]="tag.text"
            *ngFor="let tag of value"></i>
    </div>
</div>